var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBulletList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.91675 5C4.91675 4.58579 4.58096 4.25 4.16675 4.25C3.75253 4.25 3.41675 4.58579 3.41675 5V5.00833C3.41675 5.42255 3.75253 5.75833 4.16675 5.75833C4.58096 5.75833 4.91675 5.42255 4.91675 5.00833V5ZM7.5 4.25C7.08579 4.25 6.75 4.58579 6.75 5C6.75 5.41421 7.08579 5.75 7.5 5.75H16.6667C17.0809 5.75 17.4167 5.41421 17.4167 5C17.4167 4.58579 17.0809 4.25 16.6667 4.25H7.5ZM7.5 9.25C7.08579 9.25 6.75 9.58579 6.75 10C6.75 10.4142 7.08579 10.75 7.5 10.75H16.6667C17.0809 10.75 17.4167 10.4142 17.4167 10C17.4167 9.58579 17.0809 9.25 16.6667 9.25H7.5ZM6.75 15C6.75 14.5858 7.08579 14.25 7.5 14.25H16.6667C17.0809 14.25 17.4167 14.5858 17.4167 15C17.4167 15.4142 17.0809 15.75 16.6667 15.75H7.5C7.08579 15.75 6.75 15.4142 6.75 15ZM4.16675 9.25C4.58096 9.25 4.91675 9.58579 4.91675 10V10.0083C4.91675 10.4225 4.58096 10.7583 4.16675 10.7583C3.75253 10.7583 3.41675 10.4225 3.41675 10.0083V10C3.41675 9.58579 3.75253 9.25 4.16675 9.25ZM4.91675 15C4.91675 14.5858 4.58096 14.25 4.16675 14.25C3.75253 14.25 3.41675 14.5858 3.41675 15V15.0083C3.41675 15.4225 3.75253 15.7583 4.16675 15.7583C4.58096 15.7583 4.91675 15.4225 4.91675 15.0083V15Z",
    fill: "#2B2B35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletList);
export default __webpack_public_path__ + "static/media/bullet-list.ee290effb8235f49848dd20c7ac8e7bf.svg";
export { ForwardRef as ReactComponent };